import React from 'react';
import { Col, Row } from 'react-bootstrap';

import baseballIcon from 'images/insights/baseball_icon.png';
import booksIcon from 'images/insights/books_icon.png';
import briefcaseIcon from 'images/insights/briefcase_icon.png';
import buildingIcon from 'images/insights/building_icon.png';
import earthIcon from 'images/insights/earth_icon.png';
import footballIcon from 'images/insights/football_icon.png';
import palmTreeIcon from 'images/insights/palm_tree_icon.png';
import pencilIcon from 'images/insights/pencil_icon.png';
import skillsIcon from 'images/insights/skills_icon.png';
import televisionlIcon from 'images/insights/television_icon.png';

import useCurrentUser from '../../hooks/useCurrentUser';
import InsightSection from './InsightSection';
import UpdateProfileButton from './UpdateProfileButton';
import './styles.module.css';
import styles from './styles.module.css';

const entitySource_TOPIC = 'topic';
const entitySource_TI_PROFILE = 'ti_profile';
const MEMBER_FAVORITES_MAP = [
  {
    title: 'Favorite TV Shows/Movies',
    entitySource: entitySource_TI_PROFILE,
    entitySourceAttribute: 'favorite_show',
    icon: televisionlIcon,
    searchAttribute: 'favorite_show',
  },
  {
    title: 'Favorite Books',
    entitySource: entitySource_TI_PROFILE,
    entitySourceAttribute: 'favorite_book',
    icon: booksIcon,
    searchAttribute: 'favorite_book',
  },
  {
    title: 'Favorite Vacation Spots',
    entitySource: entitySource_TI_PROFILE,
    entitySourceAttribute: 'favorite_vacation_spot',
    icon: palmTreeIcon,
    searchAttribute: 'favorite_vacation_spots',
  },
  {
    title: 'Favorite Sports to Play',
    entitySource: entitySource_TI_PROFILE,
    entitySourceAttribute: 'favorite_sport_play',
    icon: baseballIcon,
    searchAttribute: 'favorite_sport_play',
  },
  {
    title: 'Favorite Sports to Watch',
    entitySource: entitySource_TI_PROFILE,
    entitySourceAttribute: 'favorite_sport_watch',
    icon: footballIcon,
    searchAttribute: 'favorite_sport_watch',
  },
];
const MEMBER_INSIGHTS_MAP = [
  {
    title: 'Companies',
    entitySource: entitySource_TI_PROFILE,
    entitySourceAttribute: 'company_name',
    icon: buildingIcon,
    searchAttribute: 'company',
  },
  {
    title: 'Locations',
    entitySource: entitySource_TI_PROFILE,
    entitySourceAttribute: 'location',
    icon: earthIcon,
    searchAttribute: 'location',
  },
  {
    title: 'Titles',
    entitySource: entitySource_TI_PROFILE,
    entitySourceAttribute: 'job_title',
    icon: briefcaseIcon,
    searchAttribute: 'list_display',
  },
  {
    title: 'Skills',
    entitySource: entitySource_TI_PROFILE,
    entitySourceAttribute: 'skill',
    icon: skillsIcon,
    searchAttribute: 'skills',
  },
];

const CommunityInsightsPage = () => {
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();

  if (!currentUser && !isLoadingCurrentUser) {
    window.location.href = '/';
    return <div></div>;
  }

  return (
    <>
      <div className="container container-padded">
        <main>
          <Row className={styles.headerContainer}>
            <Col className="col-md-8">
              <div className={styles.titleContainer}>
                <h3 className={styles.headerText}>Community Insights</h3>
                <p className={styles.secondaryText}>
                  At The Information we have the best community. Want to know what they are
                  interested in?
                </p>
              </div>
            </Col>
            <Col className="col-md-4">
              <div className={styles.updateProfileContainer}>
                Want your info to be included?
                <UpdateProfileButton />
              </div>
            </Col>
          </Row>
          {/* Member Favorites */}
          <Row className={styles.sectionHeader}>
            <Col className="col-md-12">
              <h3 className={styles.headerText}>Member Favorites</h3>
              <p className={styles.secondaryText}>
                What&apos;s everybody watching, playing or reading?
              </p>
            </Col>
          </Row>
          <Row>
            {MEMBER_FAVORITES_MAP.map((insightMap) => (
              <InsightSection
                key={insightMap.title}
                title={insightMap.title}
                entitySource={insightMap.entitySource}
                entitySourceAttribute={insightMap.entitySourceAttribute}
                icon={insightMap.icon}
                searchAttribute={insightMap.searchAttribute}
              />
            ))}
          </Row>
          {/* Hot Topics */}
          <Row className={styles.sectionHeader}>
            <Col className="col-md-12">
              <h3 className={styles.headerText}>Hot Topics</h3>
              <p className={styles.secondaryText}>What topics are our members interested in?</p>
            </Col>
          </Row>
          <Row>
            <InsightSection
              title="Topics"
              entitySource={entitySource_TOPIC}
              entitySourceAttribute={null}
              expand={true}
              icon={pencilIcon}
              searchAttribute="topics"
            />
          </Row>
          {/* Member Insights */}
          <Row className={styles.sectionHeader}>
            <Col className="col-md-12">
              <h3 className={styles.headerText}>Member Insights</h3>
              <p className={styles.secondaryText}>
                Our members are varied across industries and places.
              </p>
            </Col>
          </Row>
          <Row>
            {MEMBER_INSIGHTS_MAP.map((insightMap) => (
              <InsightSection
                key={insightMap.title}
                title={insightMap.title}
                entitySource={insightMap.entitySource}
                entitySourceAttribute={insightMap.entitySourceAttribute}
                icon={insightMap.icon}
                searchAttribute={insightMap.searchAttribute}
              />
            ))}
          </Row>
        </main>
      </div>
    </>
  );
};

export default CommunityInsightsPage;
